<div class="full-page-container">
  <div class="container px-0">
    <!--Point Summary Bar-->
    <fgb-points-summary-bar [backButtonLink]="'/rewards/raffles'" [backButtonTitle]="'Rewards'"></fgb-points-summary-bar>

    <div
      class="back-btn bg-glass-dark text-primary cursor-pointer d-none d-lg-flex align-items-center justify-content-center"
      [routerLink]="'/rewards/raffles'"
    >
      <span class="material-symbols-outlined ms-2 text-white"> arrow_back_ios </span>
    </div>
  </div>

  <!--Lotto Details-->
  <fgbcl-lotto-details-v2 [lottoId]="id" />
</div>
